var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{staticClass:"row-actions",attrs:{"variant":"row-actions","size":"sm","no-caret":"","right":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-ellipsis-h"})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }